<template>
  <LayoutContainer :props="props">
    <div
      class="kaer-image-collapse"
      :style="{
        maxHeight: maxHeight
      }"
    >
      <img :src="props.src" />
      <div class="collapse-btn-container" :class="!isCollapse ? 'is-up' : ''">
        <div
          class="collapse-btn"
          :style="{
            color: props.color,
            fontSize: px2rem(props.fontSize)
          }"
          @click="isCollapse = !isCollapse"
        >
          {{ isCollapse ? '展开更多' : '收起' }}
          <van-icon
            name="arrow-up"
            class="icon-arrow-up"
            :class="isCollapse ? 'is-down' : ''"
            :style="{
              color: props.color,
              fontSize: px2rem(props.fontSize)
            }"
          />
        </div>
      </div>
    </div>
  </LayoutContainer>
</template>

<script>
import LayoutContainer from '@/components/layout-container';
import { Icon } from '@zyf2e/capui-mobile';
import '@zyf2e/capui-mobile/lib/icon/style';
import { px2rem } from '@/utils/utils';

export default {
  name: 'kaer-customer-im',
  components: {
    LayoutContainer,
    VanIcon: Icon
  },
  props: {
    props: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      px2rem,
      isCollapse: true
    };
  },
  computed: {
    maxHeight() {
      const { props } = this;
      return this.isCollapse ? px2rem(props.minHeight) || px2rem(310) : px2rem(props.maxHeight) || px2rem(3000);
    }
  }
};
</script>

<style scoped lang="less">
.kaer-image-collapse {
  position: relative;
  overflow: hidden;
  transition: all 0.75s;
  width: 100%;

  img {
    width: 100%;
  }

  .collapse-btn-container {
    position: absolute;
    bottom: 0;
    left: 16px;
    right: 16px;
    height: 40px;
    background: #fff;
    box-shadow: 0 -20px 28px #fff;
    border-radius: 0px 0px 8px 8px;
    &.is-up {
      box-shadow: none;
    }

    .collapse-btn {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
      color: #409eff;

      .icon-arrow-up {
        position: relative;
        top: 2px;
        transition: all 0.75s;

        &.is-down {
          transform: rotate(180deg);
          transform-origin: 50% 50%;
        }
      }
    }
  }
}
</style>
